import type { PostHogInterface } from "posthog-js";
import {
    CHAT_START_FAILURE_EVENT,
    type ChatStartFailure,
    type ChatStartFailureInput,
    chatStartFailureInputSchema,
    chatStartFailureSchema,
} from "./chat-events.contract";

const SAFE_POSTHOG_METADATA_KEYS = [
    "failure_site",
    "conversation_id_present",
    "error_name",
    "error_message",
    "error_status",
] as const;

export function normalizeChatStartFailure(
    input: ChatStartFailureInput,
): ChatStartFailure {
    const parsed = chatStartFailureInputSchema.parse(input);
    const details = parsed.error;
    const errorStatus = details.status?.present
        ? details.status.value
        : details.response?.status?.value;
    return chatStartFailureSchema.parse({
        failure_site: parsed.failure_site,
        conversation_id_present: parsed.conversation_id_present,
        error_name: details.name ?? "UnknownError",
        error_message: details.message ?? "Unknown error",
        ...(errorStatus === undefined ? {} : { error_status: errorStatus }),
    });
}

export function captureChatStartFailure(
    posthog: Pick<PostHogInterface, "capture">,
    input: ChatStartFailureInput,
) {
    try {
        const event = normalizeChatStartFailure(input);
        const safeMetadata = Object.fromEntries(
            SAFE_POSTHOG_METADATA_KEYS.flatMap((key) =>
                key in event ? [[key, event[key]]] : [],
            ),
        );
        posthog.capture(CHAT_START_FAILURE_EVENT, safeMetadata);
    } catch {}
}
